<template>
  <form class="kt-form" @submit.prevent="update">

    <div v-if="user && status == 'success'">

        <div>
            <div class="h5 mb-4">
                <i class="text-primary far fa-building"></i>
                <span class="px-2">{{ $t("legal_user.label.company_info") }}</span>
            </div>
            <kt-form-section>
                <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="username">
                        {{ $t("label.username_with_hint") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        name="username"
                        id="username"
                        v-model="user.username"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t("label.email") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            name="email"
                            id="email"
                            v-model="user.email"
                        ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="com_name_fa">
                        {{ $t("label.com_name_fa") }}
                    </kt-form-label>
                    <kt-form-control
                        id="com_name_fa"
                        name="com_name_fa"
                        v-model="user.com_name_fa"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="com_name_en">
                        {{ $t("label.com_name_en") }}
                    </kt-form-label>
                    <kt-form-control
                        id="com_name_en"
                        name="com_name_en"
                        dir="ltr"
                        v-model="user.com_name_en"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="national_legal_code">
                        {{ $t("label.national_legal_code") }}
                    </kt-form-label>
                    <kt-form-control
                        id="national_legal_code"
                        name="national_legal_code"
                        v-model="user.national_legal_code"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="register_number">
                        {{ $t("label.register_number") }}
                    </kt-form-label>
                    <kt-form-control
                        id="register_number"
                        name="register_number"
                        v-model="user.register_number"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="register_date">
                        {{ $t("label.com_register_date") }}
                    </kt-form-label>
                    <datePicker
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="jDD jMMMM jYYYY"
                        input-class="form-control"
                        id="register_date"
                        name="register_date"
                        v-model="user.register_date"
                        type="date"
                    />
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="telephone">
                        {{ $t("label.telephone") }}
                    </kt-form-label>
                    <kt-form-control
                        ref="telephone"
                        dir="ltr"
                        name="telephone"
                        id="telephone"
                        v-model="user.telephone"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="phone">
                        {{ $t("label.phone") }}
                    </kt-form-label>
                        <kt-input-group class="">
                            <kt-form-control dir="ltr" name="phone" id="phone" :value="user.phone" disabled></kt-form-control>
                            <kt-input-group-append>
                                <kt-input-group-text>
                                    <a  target="_blank" :href="'https://wa.me/' + getUserPhone(user.phone)">
                                        <img class="wa-img" src="https://img.icons8.com/officexs/16/000000/whatsapp.png">
                                    </a>
                                </kt-input-group-text>
                            </kt-input-group-append>
                        </kt-input-group>
                    </kt-form-group>
                </kt-col>
                </kt-form-row>
            </kt-form-section>
        </div>

        <hr />

        <div>
            <div class="h5 mb-4">
                <i class="text-primary fas fa-file-signature"></i>
                <span class="px-2">{{
                $t("legal_user.label.signature_holder_info")
                }}</span>
            </div>
            <kt-form-section v-if="user.signature_holder">
                <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_first_name_fa">
                        {{ $t("label.first_name") }}
                    </kt-form-label>
                    <kt-form-control
                        name="signature_holder_first_name_fa"
                        id="signature_holder_first_name_fa"
                        v-model="user.signature_holder.first_name_fa"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_first_name_en">
                        {{ $t("label.first_name_en") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        name="signature_holder_first_name_en"
                        id="signature_holder_first_name_en"
                        v-model="user.signature_holder.first_name_en"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_last_name_fa">
                        {{ $t("label.last_name") }}
                    </kt-form-label>
                    <kt-form-control
                        name="signature_holder_last_name_fa"
                        id="signature_holder_last_name_fa"
                        v-model="user.signature_holder.last_name_fa"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_last_name_en">
                        {{ $t("label.last_name_en") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        name="signature_holder_last_name_en"
                        id="signature_holder_last_name_en"
                        v-model="user.signature_holder.last_name_en"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_father_name_fa">
                        {{ $t("label.father_name") }}
                    </kt-form-label>
                    <kt-form-control
                        name="signature_holder_father_name_fa"
                        id="signature_holder_father_name_fa"
                        v-model="user.signature_holder.father_name_fa"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_father_name_en">
                        {{ $t("label.father_name_en") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        name="signature_holder_father_name_en"
                        id="signature_holder_father_name_en"
                        v-model="user.signature_holder.father_name_en"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_birth_date">
                        {{ $t("label.birth_date") }}
                    </kt-form-label>
                    <datePicker
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control"
                        id="signature_holder_birth_date"
                        name="signature_holder_birth_date"
                        v-model="user.signature_holder.birth_date"
                        type="date"
                    />
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="signature_holder_national_code">
                        {{ $t("label.national_code") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        maxlength="10"
                        name="signature_holder_national_code"
                        id="signature_holder_national_code"
                        v-model="user.signature_holder.national_code"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                </kt-form-row>
            </kt-form-section>
        </div>

        <hr />

        <div>
            <div class="h5 mb-4">
                <i class="text-primary fas fa-laptop-code"></i>
                <span class="px-2">{{
                $t("legal_user.label.technical_agent_info")
                }}</span>
            </div>
            <kt-form-section v-if="user.technical_agent">
                <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="technical_agent_first_name">
                        {{ $t("label.first_name") }}
                    </kt-form-label>
                    <kt-form-control
                        name="technical_agent_first_name"
                        id="technical_agent_first_name"
                        v-model="user.technical_agent.first_name"
                    ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="technical_agent_last_name">
                        {{ $t("label.last_name") }}
                    </kt-form-label>
                    <kt-form-control
                        id="technical_agent_last_name"
                        name="technical_agent_last_name"
                        v-model="user.technical_agent.last_name"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="technical_agent_phone_number">
                        {{ $t("label.phone") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="technical_agent_phone_number"
                        name="technical_agent_phone_number"
                        v-model="user.technical_agent.phone_number"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="technical_agent_telephone_number">
                        {{ $t("label.telephone") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="technical_agent_telephone_number"
                        name="technical_agent_telephone_number"
                        v-model="user.technical_agent.telephone_number"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                    <kt-form-label for="technical_agent_email">
                        {{ $t("label.email") }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="technical_agent_email"
                        name="technical_agent_email"
                        v-model="user.technical_agent.email"
                    >
                    </kt-form-control>
                    </kt-form-group>
                </kt-col>
                    <kt-col xs="12">
                        <kt-form-group>
                            <kt-form-label for="technical_agent_national_code">
                                {{ $t("label.national_code") }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="technical_agent_national_code"
                                    name="technical_agent_national_code"
                                    v-model="user.technical_agent.national_code"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
        </div>

        <hr />
        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t('label.user_level') }}
                        </kt-form-label>
                        <kt-form-select size="3" id="user_level" class="form-control" name="user_level" v-model="user.user_level">
                            <option value="">
                                {{ $t('selectpicker.nothing_selected') }}
                            </option>
                            <option value="1" :selected="user.user_level == 1"
                            >
                                {{ $t('customers_club.l1') }}
                            </option>
                            <option
                                    value="2" :selected="user.user_level == 2"
                            >
                                {{ $t('customers_club.l2') }}
                            </option>
                            <option
                                    value="3" :selected="user.user_level == 3"
                            >
                                {{ $t('customers_club.l3') }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
            </kt-form-section>
        <div>
            <kt-form-section>
                <kt-row class="mb-3 ">
                    <kt-col lg="12" md="12" xs="12">
                        <div class="custom-control custom-switch">
                            <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="club_status"
                                    name="club_status"
                                    v-model="user.club_status"
                            >
                            <label class="custom-control-label" for="club_status">
                                {{ $t('label.club_status') }}
                            </label>
                        </div>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
        <kt-form-action class="mt-4">
            <kt-row>
                <kt-col  lg="6" md="6" xs="12">
                    <button @click="userInfoInquiry" class="btn btn-md btn-info btn-wide" type="button"
                            id="user-info-inquiry">
                        {{ $t('label.user_info_inquiry') }}
                    </button>
                </kt-col>
                <kt-col v-show="user.user_info_inquiry"  lg="6" md="6" xs="12">
                    <button class="btn btn-md btn-info btn-wide" type="button"
                            id="legal_user_info_inquiry_detail"
                            data-toggle="modal"
                            data-target="#user-info-modal">
                        {{ $t('label.user_info_inquiry_detail') }}
                    </button>
                </kt-col>
            </kt-row>
        </kt-form-action>
        <div v-if="user.user_info_inquiry" id="user-info-modal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content" id="user-info-modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('label.user_info_inquiry_detail') }}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <kt-row>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.national_legal_code') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.national_legal_code }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.activity_end_date') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.activity_end_date }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.address') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.address }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.creation_date') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.creation_date }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.issuance_date') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.issuance_date }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.name') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.name }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.postal_code') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.postal_code }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.registration_date') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.registration_date }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.register_number') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.register_number }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.company_type') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.company_type }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.telephone_number') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.telephone_number }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.email') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.email }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('user_info_inquiry.fax_number') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.fax_number }}</p>
                            </kt-col>
                        </kt-row>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <kt-form-action class="mt-4">
      <button
        class="btn btn-md btn-success btn-wide"
        type="submit"
        id="submit_btn"
      >
        {{ $t("btn.submit_changes") }}
      </button>
    </kt-form-action>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import { KTApp } from "@/plugins/core/app";
import { KTUtil } from "@/plugins/core/util";
import { userService } from "@/common/api.service";
import { i18n } from "@/plugins/i18n";
import toastr from "toastr";

export default {
  computed: {
    ...mapGetters("user", ["user", "status"]),
      toastr() {
          toastr.options = {
              closeButton: true,
              positionClass: "toast-bottom-center",
              preventDuplicates: false,
              rtl: false
          }

          return toastr
      },
  },
  data() {
    return {
      months: [
        {
          title: i18n.t("month.farvardin"),
          value: 1,
        },
        {
          title: i18n.t("month.ordibehesht"),
          value: 2,
        },
        {
          title: i18n.t("month.khordad"),
          value: 3,
        },
        {
          title: i18n.t("month.tir"),
          value: 4,
        },
        {
          title: i18n.t("month.mordad"),
          value: 5,
        },
        {
          title: i18n.t("month.shahrivar"),
          value: 6,
        },
        {
          title: i18n.t("month.mehr"),
          value: 7,
        },
        {
          title: i18n.t("month.aban"),
          value: 8,
        },
        {
          title: i18n.t("month.azar"),
          value: 9,
        },
        {
          title: i18n.t("month.day"),
          value: 10,
        },
        {
          title: i18n.t("month.bahman"),
          value: 11,
        },
        {
          title: i18n.t("month.esfand"),
          value: 12,
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.initialSetup();
    });
  },
  methods: {
      getUserPhone(phone) {
          if (phone)
              return '98' + phone.substr(-10, 10)
      },

    initialSetup() {
      setTimeout(() => {
        if (!this.$refs.selectPicker) {
          return;
        }
        let selects = $(this.$refs.selectPicker.$el).find(".kt-selectpicker");
        $(selects).selectpicker({
          size: 5,
        });
      }, 1000);
    },
    update(e) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      form.validate({
        ignore: ":hidden",

        rules: {
            username: {
                required: true,
                minlength: 5,
            },
            email: {
                required: true,
            },
            telephone: {
                required: true,
            },
            // phone: {
            //     required: true,
            // },
            com_name_fa: {
                required: true,
            },
            com_name_en: {
                required: true,
            },
            national_legal_code: {
                required: true,
            },
            register_number: {
                required: true,
            },
            register_date: {
                required: true,
            },

            signature_holder_first_name_fa: {
                required: true,
            },
            signature_holder_last_name_fa: {
                required: true,
            },
            signature_holder_father_name_fa: {
                required: true,
            },
            signature_holder_first_name_en: {
                required: true,
            },
            signature_holder_last_name_en: {
                required: true,
            },
            signature_holder_father_name_en: {
                required: true,
            },
            signature_holder_national_code: {
                required: true,
            },
            signature_holder_birth_date: {
                required: true,
            },

            technical_agent_first_name: {
                required: true,
            },
            technical_agent_last_name: {
                required: true,
            },
            technical_agent_phone_number: {
                required: true,
            },
            technical_agent_telephone_number: {
                required: true,
            },
            technical_agent_email: {
                required: true,
            },
            technical_agent_national_code: {
                required: true,
            }
        },
      });

      if (!form.valid()) {
        KTUtil.scrollTop();
        return;
      }

      let params = {
        username: this.user.username,
        email: this.user.email,
        // phone: this.user.phone,
        telephone: this.user.telephone,
        com_name_fa: this.user.com_name_fa,
        com_name_en: this.user.com_name_en,
        national_legal_code: this.user.national_legal_code,
        register_number: this.user.register_number,
        register_date: this.user.register_date,
        club_status: this.user.club_status,
        user_level: this.user.user_level,

        signature_holder_first_name_fa: this.user.signature_holder.first_name_fa,
        signature_holder_last_name_fa: this.user.signature_holder.last_name_fa,
        signature_holder_father_name_fa: this.user.signature_holder.father_name_fa,
        signature_holder_first_name_en: this.user.signature_holder.first_name_en,
        signature_holder_last_name_en: this.user.signature_holder.last_name_en,
        signature_holder_father_name_en: this.user.signature_holder.father_name_en,
        signature_holder_national_code: this.user.signature_holder.national_code,
        signature_holder_birth_date: this.user.signature_holder.birth_date,

        technical_agent_first_name: this.user.technical_agent.first_name,
        technical_agent_last_name: this.user.technical_agent.last_name,
        technical_agent_phone_number: this.user.technical_agent.phone_number,
        technical_agent_telephone_number: this.user.technical_agent.telephone_number,
        technical_agent_email: this.user.technical_agent.email,
        technical_agent_national_code: this.user.technical_agent.national_code,
      };

      KTApp.progress(btn);

      userService
        .update_legal_user_by_admin(this.user.id, params)
        .then((response) => {
          this.$store.commit("user/success", response.data.data);
          this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
            this.showMsg(form, "danger", response.data.message);
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          KTUtil.scrollTop();
          KTApp.unprogress(btn);
        });
    },
      userInfoInquiry(){
          let btn = $('#user-info-inquiry')

          KTApp.progress(btn)

          userService.userInfoInquiry(this.user.id).then(response => {
              if (response.data.data) {
                  this.user.user_info_inquiry = response.data.data;
                  setTimeout(() => {
                      const button = document.getElementById('legal_user_info_inquiry_detail');
                      button.click()
                  }, 1000);
                  return this.toastr.success(response.data.message)
              }
              return this.toastr.error(response.data.message)
          }).catch(({response}) => {
              return this.toastr.error(response.data.message)
          }).finally(() => {
              KTApp.unprogress(btn)
          })
      },
  },
};
</script>
<style scoped>
.modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, 50px);
}

.modal.show .modal-dialog {
    transform: translate(0, 0);
}

.modal-content {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background-color: #ffffff;
}

.modal-header {
    background-color: #1dc9b7;
    color: white!important;
    border-bottom: none;
    padding: 15px 25px;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h4 {
    margin: 0;
    color: white!important;
    font-size: 1.5rem;
    text-align: center;
    flex-grow: 1;
}

.modal-header .close {
    color: white;
    font-size: 1.5rem;
    opacity: 1;
    background: transparent;
    border: none;
    cursor: pointer;
}

.modal-body {
    padding: 15px;
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
}

.modal-body strong {
    font-weight: 600;
    color: #333;
}

.modal-body p {
    margin: 5px 0;
}

.modal-field {
    margin-bottom: 20px;
}

.kt-row {
    display: flex;
    flex-wrap: wrap;
}

.kt-col {
    margin-bottom: 15px;
}

.kt-col strong {
    color: #333;
}

.kt-col p {
    margin: 0;
    color: #555;
}

@media (max-width: 767px) {
    .modal-content {
        padding: 10px;
    }

    .modal-header h4 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 10px;
    }
}
</style>


